import { createUseStyles } from 'react-jss';
import { color, fontSize, radius, spacing } from '@blink/components';

export const useInfoCardStyle = createUseStyles({
    root: {
        padding: `${spacing['04']} ${spacing['05']}`,
        display: 'flex',
        gap: spacing['03'],
        borderRadius: 4,
        '& svg': {
            minWidth: 20,
            minHeight: 20,
        },
    },
    success: {
        background: color.background.lightPositive,
        color: color.content.green800,
    },
    alert: {
        background: color.background.lightWarning,
        color: color.content.orange800,
    },
    error: {
        background: color.background.lightNegative,
        color: color.content.red800,
    },
    info: {
        color: color.content.primary,
        background: color.content.lightAccent,
    },
    tooltipRoot: {
        borderRadius: radius.overall,
        width: 'fit-content',
        '& .ant-tooltip-arrow': {
            top: 1,
        },
        '& .ant-tooltip-inner': {
            display: 'flex',
            minWidth: 96,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: spacing['02'],
            padding: '8px 12px',
            border: `1px solid transparent`,
            background: `${color.background.inversePrimary} !important`,
        },
        '& .ant-tooltip-arrow:before': {
            background: `${color.background.inversePrimary} !important`,
        },
        '&.ant-tooltip': {
            fontSize: `${fontSize.sm} !important`,
            maxWidth: 320,
            color: color.content.inversePrimary,
        },
    },
});
